// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1nhvK","calendarButtons":"ClockData_calendarButtons__1rCO-"};